/**
 * Get the theme image thumb url
 * @returns {string}
 */
export function getThemeThumbUrl(themeKey) {
  // @TODO - theme images not yet available
  // return `https://koalaboss-app-theme-images.s3.ap-southeast-2.amazonaws.com/${themeKey}.png`
  return process.env.VUE_APP_THEME_PLACEHOLDER_IMAGE_URL;
}
